import { css } from '@emotion/react'
import styles, { colors, typo } from '@mathflat/common/style'

const {
  colors: { gray, primary, red, blue },
} = styles

const S = {
  default: css`
    display: flex;
    flex-direction: column;
    width: 350px;

    .calendar-container {
      background-color: white;
      border-radius: var(--Radius-100);
    }

    .calendar-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 65px;
      padding: 0 20px;
      border-radius: var(--Radius-100) 4px 0 0;
      background-color: ${blue.$300};

      > .multi-select-dropdown-button {
        position: absolute;
        top: 50%;
        left: 50%;
        display: flex;
        align-items: center;
        color: white;
        ${typo.heading04};
        font-weight: 700;
        transform: translate(calc(-50% + 16px), calc(-50% + 16px));

        .group-arrow-box {
          width: 16px;
          height: 16px;
          margin-left: 7px;
          border-radius: var(--Radius-100);
          background-color: white;
        }
      }
      > button {
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        margin: -16px;
        padding: 16px;

        > p {
          font-weight: 700;
        }
      }
    }

    .calendar-weekly-list {
      display: flex;
      flex-direction: column;
      gap: 4px;
      height: 100%;
      justify-content: space-between;
      padding: 16px 16px 12px 16px;
      .calendar-weekly-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        font-size: 16px;
        border-radius: var(--Radius-100);

        &:hover:not(.selected-week-item):not(.disabled),
        &:active:not(.selected-week-item):not(.disabled) {
          cursor: pointer;
          background: ${colors.gray.$200};
        }

        &.disabled {
          color: ${colors.gray.$500};
        }
      }
      .selected-week-item {
        background-color: ${colors.blue.$300};
        font-weight: 700;
        color: white;
      }

      .weekly-guide {
        margin-top: 4px;
        ${typo.caption01};
        font-weight: 500;
        text-align: center;
        color: var(--Colors-Gray-500);
      }
    }

    .calendar-body-container {
      height: 310px;
      border: 1px solid ${gray.$400};
      border-top: none;
      border-radius: 0px 0px var(--Radius-100) var(--Radius-100);

      &.has-footer {
        border-bottom: none;
        border-radius: 0px;
      }
    }

    .calendar-body {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      height: 100%;
      padding: 14px 16px;
    }

    .calendar-date {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      font-weight: 700;
    }

    .calendar-day {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      ${typo.body01};

      > span {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;
        transform: translateY(2px);
      }

      &:disabled {
        color: ${gray.$500};
        cursor: not-allowed;
      }

      &:active:enabled {
        &:before {
          position: absolute;
          display: block;
          width: 32px;
          height: 32px;
          border-radius: var(--Radius-Circle);
          content: '';
          background-color: ${blue.$100};
        }
      }
    }
    .pointed {
      &.small {
        &:after {
          position: absolute;
          content: '';
          width: 3px;
          height: 3px;
          left: 50%;
          bottom: 1px;
          border-radius: var(--Radius-Circle);
          background: ${primary};
          transform: translateX(-50%);
        }
      }

      &.big {
        &:after {
          position: absolute;
          content: '';
          width: 8px;
          height: 8px;
          left: 50%;
          bottom: 6px;
          border-radius: var(--Radius-Circle);
          background: ${primary};
          transform: translateX(-50%);
        }
      }

      &.selected:after {
        background: white;
      }
    }
    .today,
    .selected {
      &:before {
        position: absolute;
        content: '';
        display: block;
        width: 32px;
        height: 32px;
        border-radius: var(--Radius-Circle);
      }
    }

    .today:before {
      box-sizing: border-box;
      border: 1px solid ${blue.$300};
    }

    .selected {
      span {
        color: white;
      }
      &:before {
        background-color: ${primary};
      }
    }

    .range-start {
      span {
        color: var(--White);
      }
      &:before {
        position: absolute;
        content: '';
        display: block;
        width: 32px;
        height: 32px;
        border-radius: var(--Radius-Circle);
        background-color: var(--Colors-Sky-400);
        z-index: 1;
      }

      &.has-range:after {
        position: absolute;
        content: '';
        display: block;
        left: 50%;
        width: 50%;
        height: 32px;
        background-color: var(--Colors-Sky-100);
        z-index: 0;
      }
    }

    .range-end {
      span {
        color: var(--White);
      }
      &:before {
        position: absolute;
        content: '';
        display: block;
        width: 32px;
        height: 32px;
        border-radius: var(--Radius-Circle);
        background-color: var(--Colors-Sky-400);
        z-index: 1;
      }

      &.has-range:after {
        position: absolute;
        content: '';
        display: block;
        width: 50%;
        right: 50%;
        height: 32px;
        background-color: var(--Colors-Sky-100);
        z-index: 0;
      }
    }

    .in-range {
      position: relative;
      &:after {
        position: absolute;
        content: '';
        display: block;
        width: 100%;
        height: 32px;
        background-color: var(--Colors-Sky-100);
        z-index: 0;
      }
    }

    .sunday {
      color: ${red.$400} !important;
    }

    ul {
      max-height: none;
      height: 100%;
      padding: 18px 20px 16px;
      border: none;
    }
    .multiple-select-item {
      margin: 0 !important;
      padding: 0 !important;

      button {
        ${typo.body01};
      }
    }
  `,
}

export default S
